import React from "react";
import { ReactNode } from "react";
import { Typography, TypographyProps } from "@mui/material";
import { formatText } from "../../../helper/formatText";
import { Done } from "@mui/icons-material";

import "./style.scss";

interface IErrorMessageProps {
    withRetry?: false;
    children: ReactNode;
    onCancel?: () => void;
}

export const Success = (props: IErrorMessageProps) => {
    return <div className={"success-wrapper"}>
        <div className={"success"}>
            <Done className={"success-icon"} color={"primary"} />
            {React.Children.map(props.children, el =>
                React.isValidElement<TypographyProps>(el) ?
                    React.cloneElement(el, {
                        ...el.props,
                        className: `${el.props.className} error-text`,
                        children: !React.isValidElement(el.props.children) ?
                            formatText(el.props.children as string) : el.props.children,
                    }) : el && <Typography className={"error-text"}>{formatText(el as string)}</Typography>)}
        </div>
    </div>;
};
